import AnalyticsEvent from './AnalyticsEvent';
import type GaItemList from './GaItemList';

export default class ChipAnalytics extends AnalyticsEvent<Pick<GaItemList, 'content_type' | 'content_id'> & { event: string }> {
	static readonly CONTENT_TYPE = 'ux_chip';

	fireChipSelected(): void {
		super.fireGoogleAnalyticsEventOrAddListener('select_content');
	}

	static createInstance(event: { event: string; contentType: string; contentId: string }): ChipAnalytics {
		return new ChipAnalytics({
			event: event.event, // Ensure 'event' is part of the extended type
			content_type: event.contentType,
			content_id: event.contentId,
		});
	}
}
